import {
  AfterContentInit,
  Component,
  ContentChild,
  ElementRef,
  Input,
} from '@angular/core';

import { BackLinkInterface } from '~/checkout/interfaces/back-link.interface';
import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';

@Component({
  selector: 'app-checkout-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class CheckoutLayoutComponent implements AfterContentInit {
  @ContentChild('rightColumn') public content: ElementRef;
  @Input() public backLink: BackLinkInterface;
  @Input() public backLinkAriaLabel: string;
  @Input() public description: string;
  @Input() public hasLargeColumn: boolean;
  @Input() public title: string;

  public readonly logoName = LogoTypeEnum.Regular;

  public hasAside = false;

  public ngAfterContentInit(): void {
    this.hasAside = Boolean(this.content?.nativeElement.children.length);
  }
}
